<template>
    <div>
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-2">
                        <router-link to="/new-game/multiplayer" class="btn btn--icon btn--white"><i class="material-icons">keyboard_arrow_left</i></router-link>
                    </div>

                    <div class="col-8">
                        <h1 class="header__title">Play with a friend</h1>
                    </div>
                </div>
            </div>
        </header>

        <section class="container animated fadeIn">
            <div class="intro-content pt--40">
                <div class="profile profile--vertical profile--lg mb--20">
                    <figure class="profile__avatar">
                        <span class="profile__avatar__img">
                            <img :src="avatar" alt="" />
                        </span>
                    </figure>

                    <div class="profile__text">
                        <div class="profile__name">Choose one</div>
                    </div>
                </div>
            </div>

            <button-link :to="'/game/invited-multiplayer'" class="btn btn--block btn--white btn--left-icon mb--md"><img src="/img/icons/add.svg" alt="" />Create room</button-link>
            <button-link :to="'/game/find-game'" class="btn btn--block btn--white btn--left-icon mb--md"><img src="/img/icons/find.svg" alt="" />Find opponent</button-link>
        </section>

        <navigation></navigation>
    </div>
</template>

<script>
    import Navigation from "./partial/Navigation";
    import { mapGetters } from 'vuex'
    import ButtonLink from "./partial/ButtonLink";

    export default {
        components: {ButtonLink, Navigation },

        computed: {
            ...mapGetters('auth', [
                'avatar',
            ]),
        }
    }
</script>
